import type { Mouvement } from '@mairistem/comptabilite';
import type React from 'react';
import ProjetComponent from '../../../components/Mouvement/Panel/ProjetComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import type PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';
import LignePanel from './LignePanel';

class ProjetPanel extends LignePanel {
	constructor(isMandatory = false) {
		super(isMandatory);
		this.code = CODE_PANEL.PROJET;
		this.icon = { name: 'briefcase' };
	}

	getLibelle = () => 'Projet';

	isEmpty = (data: Mouvement) =>
		!data?.lignes?.find((ligne) => ligne?.identifiantProjet);

	getComponent = function getComponent(
		data: PanelComponentProps['data'],
		onChange: PanelComponentProps['onChange'],
		handlePin: PanelComponentProps['handlePin'],
	): React.ReactElement {
		return (
			<ProjetComponent
				data={data}
				handlePin={handlePin}
				onChange={onChange}
				panel={this}
			/>
		);
	};
}

export default ProjetPanel;
